import { useAtomValue } from "jotai";
import { AppStateAtom } from "@/store/AppStateAtom";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useSocket } from "@/hooks/useSocket";
import { HubConnectionState } from "@microsoft/signalr";
import { SelectedFundAtom } from "@/store/FundStateAtom";
import { SelectedReportingPeriodAtom } from "@/store/ReportingPeriodStateAtom";

interface UseAppShellController {
  loading: boolean;
  selectedFund: string | undefined;
  selectedReportingPeriod: string | undefined;
}

export const useAppShellController = (): UseAppShellController => {
  const initialised = useRef(false);
  const appState = useAtomValue(AppStateAtom);
  const selectedFund = useAtomValue(SelectedFundAtom);
  const selectedReportingPeriod = useAtomValue(SelectedReportingPeriodAtom);
  const socket = useSocket();

  const subscribe = useCallback(() => {
    setTimeout(() => {
      const clientKey = localStorage.getItem("clientKey") || "NoClientKey";
      socket.subscribe(clientKey);
    }, 100);
  }, [socket]);

  useEffect(() => {
    if (initialised.current) {
      if (
        socket.connectionState === HubConnectionState.Disconnected ||
        socket.connectionState === HubConnectionState.Disconnecting
      ) {
        subscribe();
      }
    }
  }, [socket.connectionState]);

  useEffect(() => {
    if (!initialised.current && appState.user && socket.socketCreated) {
      initialised.current = true;
      subscribe();
    }
  }, [socket.socketCreated]);

  return {
    loading: appState.loading,
    selectedFund: selectedFund?.fundKey || undefined,
    selectedReportingPeriod:
      selectedReportingPeriod?.reportingPeriodId || undefined,
  };
};
